const styles = `:host {
  background-color: var(--goto-snackbar-background);
  box-sizing: border-box;
  min-height: 48px;
  min-width: 320px;
  max-width: 408px;
  display: inline-flex;
  border-radius: 4px;
  box-shadow: var(--goto-elevation-300);
  color: var(--goto-text-04);
  padding: 12px 16px;
  --goto-button-margin: 0 2px;
}
:host ::slotted([slot=action]) {
  display: flex;
  gap: var(--goto-spacing-01);
  align-items: center;
  margin-left: var(--goto-spacing-03);
}
:host ::slotted([slot=progress]) {
  margin-top: var(--goto-spacing-02);
}
:host .actions {
  display: flex;
  justify-content: flex-end;
}
:host .message {
  display: flex;
  flex-direction: column;
  width: 100%;
}
:host .message ::slotted([slot=title]) {
  margin: 0;
  font: var(--goto-body-small);
  color: var(--goto-text-04);
}
:host .message ::slotted([slot=message]) {
  margin: 0;
  font: var(--goto-caption-default-01);
  color: var(--goto-snackbar-content-color);
}

:host([stacked]) {
  flex-direction: column;
}
:host([stacked]) .actions {
  padding-top: var(--goto-spacing-04);
}

:host([centered]) {
  align-items: center;
  gap: 0;
}
:host([centered]) .message {
  align-items: center;
}`; export default styles;